/*eslint-disable*/
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/Nantsoina.jpeg";
import team2 from "assets/images/zouzou.jpeg";
import team3 from "assets/images/ivana-squares.jpg";
import team4 from "assets/images/ivana-square.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
          <MKTypography variant="h3" color="white">
  Références
</MKTypography>
<MKTypography variant="body2" color="white" opacity={0.8}>
  Ci-dessous, vous trouverez les contacts de professionnels et clients avec lesquels j'ai collaboré. 
  Ils peuvent témoigner de mon travail, de ma rigueur et de mon professionnalisme.
</MKTypography>

          </Grid>

        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
            <HorizontalTeamCard
  image={team1}
  name="Nantsoina Rakotozanany"
  position={{ color: "info", label: "NR Consult" }}
  description={
    <>
      Poste : Manager<br />
      Téléphone : +261 33 02 002 44<br />
      Email : nantsoina.r@nrconsult.fr
    </>
  }
/>

            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Natolotra Rakotozafy"
                position={{ color: "info", label: "Natiora Mania" }}
                description={
                  <>
                    Poste : Gerante <br />
                    Téléphone : +261 34 28 607 04<br />
                    Email : contact@natioramania.com
                  </>
                }
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Mahandry Rajaonarifetra "
                position={{ color: "info", label: "UNIFOODS Antsirabe" }}
                description={
                  <>
                    Poste : Résponsble de Zone <br />
                    Téléphone : +261 34 05 154 53<br />
                    Email : mahandry.rajaonarifetra@gmail.com
                  </>
                } />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Njaka  Rakotonirina"
                position={{ color: "info", label: "Cabine Veterinaire d'Ambalavao" }}
                description={
                  <>
                    Poste : Docteur vétérinaire, propriétaire du cabinet <br />
                    Téléphone : +261 34 14 330 75<br />
                    Email : najaka.Rakotonirina@gmail.com
                  </>
                } />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
